import { pathOr } from 'ramda'
import axios from 'axios'

import {
  FETCH_CONDITIONS_REQUEST,
  FETCH_CONDITIONS_SUCCESS,
  RESET_CONDITIONS_SUCCESS,
} from '../../search/constants'
import openPopup from '../../PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from '../../PopupConstructor/constants'

const fetchConditionsRequest = () => ({
  type: FETCH_CONDITIONS_REQUEST,
})

const fetchConditionsSuccess = payload => ({
  type: FETCH_CONDITIONS_SUCCESS,
  payload,
})

export const resetConditions = () => ({
  type: RESET_CONDITIONS_SUCCESS,
})

export default params => async (dispatch) => {
  const FETCH_CONDITIONS_ENDPOINT = pathOr('', ['drupalSettings', 'rooms', 'rates', 'conditionsURL'], window)

  try {
    const { data } = await axios.get(FETCH_CONDITIONS_ENDPOINT, { params })
    dispatch(fetchConditionsSuccess(data))
  } catch (e) {
    const data = pathOr({}, ['response', 'data'], e)
    if (data.message) {
      dispatch(openPopup(GLOBAL_ERROR_POPUP, data))
    }
  }
}
